import { defineStore } from 'pinia';
import { useAuth } from '@/composables/useAuth';
import { useRouter } from 'vue-router';
import { useUserStore } from '@/stores/user';
import { usePermissionsStore } from '@/stores/permissions';
import { useProjectStore } from '@/stores/project';

export const useAuthStore = defineStore('auth', () => {
  const router = useRouter();
  const userStore = useUserStore();
  const permissionsStore = usePermissionsStore();
  const projectStore = useProjectStore();
  const { logoutMutation, logoutMutationLoading } = useAuth();

  async function logout() {
    try {
      await logoutMutation();
    } catch (e) {
      console.error('Error logging out:', e);
    } finally {
      localStorage.removeItem('access_token');
      localStorage.removeItem('vueuse-color-scheme');
      localStorage.removeItem('columnSelector');
      localStorage.removeItem('redirectAfterLogin');
      userStore.reset();
      permissionsStore.reset();
      projectStore.reset();
      router.push({ path: '/login' }).then(() => {
        window.location.reload();
      });
    }
  }

  return {
    logout,
    logoutMutationLoading,
  };
});
